var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDino(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-dino_svg__clip0_3315_48001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#42ABE9",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D1013",
    fillRule: "evenodd",
    d: "M15.598 57.474l-5.707-4.26 4.207-4.717-5.803-4.757 5.869-5.867-7.626-5.224 7.835-5.64 1.219 30.458.006.007z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6170",
    fillRule: "evenodd",
    d: "M43.291 47.875s-.313 3.57-1.152 7.631c-2.627 12.726-1.443 16.184-5.346 30.751-1.16 4.332-1.741 6.491-2.156 7.092-6.431 9.211-23.08 2.754-45.084 12.957a69.66 69.66 0 00-2.58 1.266 22.48 22.48 0 012.555-4.539 22.674 22.674 0 014.317-4.471c3.861-3.627 7.498-5.863 10.304-7.28 3.896-1.97 5.813-2.114 7.717-4.189 3.11-3.393 3.152-8.051 3.127-11.694a1835.41 1835.41 0 00-.944-49.385s.98.244 2.582.733c3.94 1.195 11.642 3.85 17.818 7.894 2.758 1.81 8.836 13.234 8.836 13.234h.007z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC500",
    fillRule: "evenodd",
    d: "M34.456 34.635l-.075-.005c-10.297-.815-13.319 7.216-8.087 9.083 0 0 .168 30.784-.543 37.597-.544 5.2-1.78 8.487-6.388 11.232-9.732 5.799-20.245 5.315-29.81 13.757 3.37-1.333 10.484-3.336 23.897-4.107 4.944-.312 8.81-1.468 11.353-2.434 3.486-1.327 6.93-2.636 9.591-5.848 2.545-3.06 3.229-6.404 3.542-8.434 2.186-13.927 5.16-32.78 5.16-32.78.023-.17.098-.672.18-1.332.235-1.842.357-3.218.36-3.272.14-1.738-3.579-7.09-9.194-13.458h.014z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6170",
    fillRule: "evenodd",
    d: "M54.887 35.873c-.318-9.331-9.15-9.89-22.9-9.89-5.255 0-17.802-.085-17.802-.085.59 6.916 3.397 11.26 4.675 13.484 7.448 12.948 23.673 12.333 24.377 12.35 3.553.1 9.754-.042 10.49-.099 0 0 1.47-6.423 1.153-15.76h.007z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6170",
    fillRule: "evenodd",
    d: "M51.631 24.264c2.041.615 2.926 3.283 1.983 5.95-.943 2.673-3.365 4.337-5.406 3.722-2.04-.615-2.925-3.283-1.983-5.95.943-2.673 3.366-4.337 5.406-3.722z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D1013",
    fillRule: "evenodd",
    d: "M51.465 26.746c.705.386.824 1.625.264 2.765-.56 1.14-1.586 1.757-2.29 1.37-.706-.386-.824-1.625-.264-2.765.56-1.14 1.586-1.757 2.29-1.37z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6170",
    fillRule: "evenodd",
    d: "M58.38 28.873c1.5 1.134 1.285 3.64-.496 5.599-1.774 1.959-4.43 2.625-5.93 1.49-1.5-1.133-1.285-3.64.496-5.598 1.774-1.959 4.43-2.625 5.93-1.491z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D1013",
    fillRule: "evenodd",
    d: "M57.114 30.564c.528.5.323 1.522-.464 2.281-.786.76-1.858.97-2.386.469-.528-.5-.323-1.523.463-2.282.787-.759 1.859-.969 2.387-.468zM20.105 9.446c1.264-.097 2.203.268 2.393 1.079.19.81-.702 1.605-1.46 1.825-.757.22-2.632 1.879-3.119 2.284-.48.399-1.462.34-1.904-.101-.435-.441-.327-1.311-.036-1.905.729-1.467 2.236-3.036 4.12-3.182h.006zm14.335.825c-1.268-.102-2.212.266-2.406 1.083-.194.818.7 1.626 1.462 1.85.762.226 2.643 1.907 3.128 2.317.485.402 1.467.345 1.908-.097.441-.442.337-1.324.04-1.921-.721-1.483-2.238-3.076-4.126-3.225l-.006-.007z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F568E",
    fillRule: "evenodd",
    d: "M21.009 15.475c4.196.224 7.42 3.803 7.197 8-.223 4.197-3.81 7.414-8.006 7.191a7.61 7.61 0 01-7.198-8c.223-4.197 3.81-7.414 8.007-7.19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F568E",
    fillRule: "evenodd",
    d: "M32.448 15.407a7.61 7.61 0 017.198 8 7.609 7.609 0 01-8.007 7.19 7.61 7.61 0 01-7.198-8 7.61 7.61 0 018.007-7.19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.864 18.191a4.887 4.887 0 11-.52 9.759 4.891 4.891 0 01-4.626-5.14 4.891 4.891 0 015.146-4.619z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D1013",
    fillRule: "evenodd",
    d: "M20.727 20.764a2.307 2.307 0 012.185 2.43 2.307 2.307 0 01-2.43 2.184 2.307 2.307 0 01-2.184-2.43 2.307 2.307 0 012.43-2.184z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.303 18.116a4.887 4.887 0 11-.519 9.759 4.891 4.891 0 01-4.627-5.14 4.891 4.891 0 015.146-4.619z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D1013",
    fillRule: "evenodd",
    d: "M32.167 20.695a2.307 2.307 0 012.184 2.43 2.307 2.307 0 01-2.43 2.184 2.307 2.307 0 01-2.184-2.43 2.307 2.307 0 012.43-2.184z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.243 51.732c-3.137-.195-8.278-1.064-12.861-2.909-3.598-1.444-8.062-3.995-8.852-7.91a.624.624 0 00-.727-.484.624.624 0 00-.484.727c1.616 7.963 15.8 11.346 22.757 11.792.017-.06.178-1.16.168-1.223v.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.65 44.19l-.584 5.568 5.9-1.185 1.715 5.217 5.425-2.421 2.844 4.689 4.478-3.505-1.527-.636-7.47-1.732-5.854-2.379-4.927-3.615z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-dino_svg__clip0_3315_48001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    rx: 10
  })))));
}
export default SvgIconDino;